import React from 'react';
import { DashboardLayout } from '../../layouts/DashboardLayout';
import { ShoppingBag } from 'lucide-react';

const ComprarAddons = () => {
  return (
    <DashboardLayout>
      <div className="max-w-2xl mx-auto py-12">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-teal-100 rounded-full mb-4">
            <ShoppingBag className="w-8 h-8 text-teal-600" />
          </div>
          <h1 className="text-3xl font-bold text-slate-900">Comprar Addons</h1>
          <p className="text-slate-500 mt-2">
            Proximamente podras comprar complementos adicionales para tu negocio
          </p>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 p-6 text-center">
          <p className="text-sm text-slate-500">
            Los complementos y addons estaran disponibles proximamente.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ComprarAddons;
